import { ContextMenuButton } from '@ordr-as/umami-react/context-menu-button';
import type { Dispatch, SetStateAction } from 'react';
import { useLocation } from '../../../../../context/LocationContext';
import DiscountMenuItem from './DiscountMenuItem';
import EmptyCartMenuItem from './EmptyCartMenuItem';
import WastageMenuItem from './WastageMenuItem';

interface OptionsContextMenuProps {
  setOpenWasteDialog: Dispatch<SetStateAction<boolean>>;
  setOpenEmptyCartDialog: Dispatch<SetStateAction<boolean>>;
  setOpenDiscountDialog: Dispatch<SetStateAction<boolean>>;
}

const OptionsContextMenu = (props: OptionsContextMenuProps) => {
  const { setOpenWasteDialog, setOpenEmptyCartDialog, setOpenDiscountDialog } = props;
  const { location } = useLocation();

  return (
    <ContextMenuButton label="" backdrop={false} className="h-[40px] border-none">
      <DiscountMenuItem setOpenDiscountDialog={setOpenDiscountDialog} />
      {location.canUseWastage && <WastageMenuItem setOpenWasteDialog={setOpenWasteDialog} />}
      <EmptyCartMenuItem setOpenEmptyCartDialog={setOpenEmptyCartDialog} />
    </ContextMenuButton>
  );
};

export default OptionsContextMenu;
